import { useReselector } from '@/utils/sharedHooks'
import { selectShouldShowSmsBanner } from '@/components/platform-banners/banner.selectors'
import { SmsConsentDialog } from './ConsentDialog'
import { SmsConsentSource } from './smsConsentReducer'

export const SmsConsentButton = () => {
  const shouldShow = useReselector(selectShouldShowSmsBanner)

  if (!shouldShow) return null

  return (
    <SmsConsentDialog
      source={SmsConsentSource.PAGE_HEADER}
      buttonStyle="ghost"
    />
  )
}
